import { createApp } from 'vue'
import App from './App.vue'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import store from "./store"
import axios from 'axios'
import URI from './constants'
import  { fun_comma } from './comma'
import  { functions } from './function'
import dayjs from "dayjs";

loadFonts()

const app = createApp(App).use(router).use(store)

app.config.globalProperties.$axios = axios
app.config.globalProperties.$uri = URI
app.config.globalProperties.$comma = fun_comma.comma
app.config.globalProperties.$uncomma = fun_comma.uncomma
app.config.globalProperties.$f = functions
app.config.globalProperties.$dayjs = dayjs
  app.mount('#app')
